// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap__19_Yx","contact":"contact__2Yl1P","name":"name__12AJJ","description":"description__hcDVb","number":"number__2D7d0"};